/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsPlusIcon20Light = forwardRef('DocsPlusIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 9.5a.5.5 0 0 1 .5.5v2h2a.5.5 0 1 1 0 1h-2v2a.5.5 0 1 1-1 0v-2H7a.5.5 0 0 1 0-1h2v-2a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h3.622a1.5 1.5 0 0 1 1.06.44l3.879 3.877A1.5 1.5 0 0 1 16 7.378V15ZM5 5a2 2 0 0 1 2-2h3v3a2 2 0 0 0 2 2h3v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5Zm9.83 2H12a1 1 0 0 1-1-1V3.17L14.83 7Z" }),
        React.createElement("path", { d: "M18 8.5a.5.5 0 0 0-1 0v7a3.5 3.5 0 0 1-3.5 3.5h-5a.5.5 0 0 0 0 1h5a4.5 4.5 0 0 0 4.5-4.5v-7Z" })));
});
